import net from "App/net";

var BenefitsClient = function () {

};

BenefitsClient.prototype.find = function (trendEventId, longTrendId) {
  var filter = {
    trendEventId: trendEventId,
    longTrendId: longTrendId,
  };

  return net.get("/Benefits/Find", filter);
  // return {
  //   "draft": 9,
  //   "prevEndValue": -20.911822103934245,
  //   "nextBenchmarkValue": -14.7964401943379915,
  //   "benefitDate": "2016-10-31T00:00:00Z",
  //   "consequences": [{
  //       "vesselId": 118,
  //       "mcrDisplay": "40% (10591 kW)",
  //       "diagnosticTypeId": 302,
  //       "diagnosticTypeName": "Speed",
  //       "results": []
  //     },
  //     {
  //       "vesselId": 118,
  //       "mcrDisplay": "50% (13239 kW)",
  //       "diagnosticTypeId": 302,
  //       "diagnosticTypeName": "Speed",
  //       "results": []
  //     },
  //     {
  //       "vesselId": 118,
  //       "mcrDisplay": "75% (19858 kW)",
  //       "diagnosticTypeId": 302,
  //       "diagnosticTypeName": "Speed",
  //       "results": []
  //     },
  //     {
  //       "vesselId": 118,
  //       "mcrDisplay": "90% (23830 kW)",
  //       "diagnosticTypeId": 302,
  //       "diagnosticTypeName": "Speed",
  //       "results": []
  //     }
  //   ]
  // }
};

export default new BenefitsClient();
